// File: src/components/checkout/ShippingSummary.js
import React, { useMemo } from "react";
import { useLanguage } from "../../contexts/LanguageContext";

export default function ShippingSummary({ subtotal = 0, shippingMethod }) {
  const { lang } = useLanguage();
  const isAr = lang === "ar";

  const labels = useMemo(
    () => ({
      title: isAr ? "ملخص الطلب" : "Order Summary",
      subtotal: isAr ? "المجموع الفرعي" : "Subtotal",
      shipping: isAr ? "الشحن" : "Shipping",
      total: isAr ? "الإجمالي" : "Total",
      selectShipping: isAr
        ? "يتم تحديده بعد اختيار طريقة الشحن"
        : "Select a shipping method",
      estimated: isAr ? "المدة المتوقعة:" : "Estimated delivery:",
      free: isAr ? "مجاني" : "Free",
    }),
    [isAr]
  );

  const sub = Number(subtotal || 0);
  const shippingPrice = shippingMethod ? Number(shippingMethod?.price || 0) : 0;
  const total = sub + shippingPrice;

  const shippingText = shippingMethod
    ? shippingPrice > 0
      ? `${shippingPrice.toFixed(2)} $`
      : labels.free
    : labels.selectShipping;

  return (
    <div className="card shadow-sm">
      <div className="card-header fw-semibold">{labels.title}</div>

      <div className="card-body">
        <div className="d-flex justify-content-between mb-1">
          <span>{labels.subtotal}</span>
          <span>{sub.toFixed(2)} $</span>
        </div>

        <div className="d-flex justify-content-between mb-1">
          <span>{labels.shipping}</span>
          <span className={!shippingMethod ? "text-muted" : ""}>
            {shippingText}
          </span>
        </div>

        <hr />

        <div className="d-flex justify-content-between fw-bold">
          <span>{labels.total}</span>
          <span>{total.toFixed(2)} $</span>
        </div>

        {shippingMethod?.estimated_days && (
          <div className="small text-muted mt-2">
            {labels.estimated} {shippingMethod.estimated_days}
          </div>
        )}
      </div>
    </div>
  );
}
